import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import AppLoading from './AppLoading';
import { toast } from 'react-toastify';

const LoadingWallet = () => {
  const navigate = useNavigate();
  const { wallet, loading } = useWallet();
  const [hasShownToast, setHasShownToast] = useState(false);
  const [loadingStep, setLoadingStep] = useState(0);
  const loadingSteps = [
    'Initializing wallet...',
    'Configuring settings...',
    'Syncing with network...',
    'Almost ready...'
  ];

  const showInitializedToast = useCallback(() => {
    if (!hasShownToast) {
      toast.success('Wallet initialized successfully!');
      setHasShownToast(true);
    }
  }, [hasShownToast]);

  useEffect(() => {
    // Cycle through loading steps
    const stepInterval = setInterval(() => {
      setLoadingStep(prev => (prev + 1) % loadingSteps.length);
    }, 2000);

    // Check if wallet is initialized
    const checkWallet = () => {
      console.log('LoadingWallet: checking wallet state', { 
        wallet: !!wallet, 
        loading, 
        walletData: wallet ? {
          hasTonAddress: !!wallet.ton?.address,
          hasBnbAddress: !!wallet.bnb?.address,
          hasMnemonic: !!wallet.mnemonic
        } : null
      });
      
      if (!loading) {
        if (wallet && wallet.ton?.address) {
          console.log('LoadingWallet: wallet found, navigating to home');
          showInitializedToast();
          navigate('/home', { replace: true });
        } else {
          console.log('LoadingWallet: no wallet found, navigating to welcome');
          // If no wallet is found, redirect to welcome
          navigate('/welcome', { replace: true });
        }
      } else {
        console.log('LoadingWallet: still loading, waiting...');
      }
    };

    // Initial check after animation
    const timer = setTimeout(checkWallet, 2500);

    return () => {
      clearTimeout(timer);
      clearInterval(stepInterval);
    };
  }, [navigate, wallet, loading, showInitializedToast]);

  return <AppLoading text={loadingSteps[loadingStep]} />;
};

export default LoadingWallet;
